<template>
    <div>
        <h1>Zip Assets</h1>
        <h2>Em desenvolvimento...</h2>
    </div>
</template>

<script>

export default {
    name: "ZipAssets",
    data() {
        return {
        };
    },
    components: {
        
    },
    methods: {
       
    },
    mounted() {
        this.getItems();
    },
}
</script>

<style scoped>

</style>